if (!customElements.get('module-five')) {
  class ModuleFive extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.keyArray = this.dataset.keyString.toLowerCase().split(',').filter(item => item.trim() !== "");
      this.valArray = this.dataset.valString.toLowerCase().split(',').filter(item => item.trim() !== "");
      this.keyArray = this.keyArray.map(item => item.replace(/\n/g, ''));
      this.valArray = this.valArray.map(item => item.replace(/\n/g, ''));
      this.targetTable = this.querySelector('.compare-section table');

      this.accordionToggle();
      this.stickyBtns();
      this.tableScroll();
      this.dropwdownChange();
    }
    accordionToggle() {
      this.toggleBtns = this.querySelectorAll('.compare-row--toggle');

      this.toggleBtns.forEach(btn => {
        btn.addEventListener('click', event => {
          event.currentTarget.classList.toggle('compare-row--close');
        })
      })
    }
    stickyBtns() {
      this.stickyBtns = this.querySelectorAll('.compare-section--sticky-btn');
      this.contentTHs = this.querySelectorAll('th');

      this.stickyBtns.forEach(btn => {
        btn.addEventListener('click', event => {
          event.preventDefault();
          const currentTarget = event.currentTarget;
          setTimeout(() => {
            this.stickyBtns.forEach(item => {
              item.classList.remove('active');
            });
            currentTarget.classList.add('active');
          }, 400);

          const itemIndex = btn.getAttribute('data-item-index');
          const targetTH = Array.from(this.contentTHs).find(th => th.getAttribute('data-item-index') === itemIndex);
          if (targetTH) {
            const scrollLeft = targetTH.offsetLeft;
            if (this.targetTable)
            this.targetTable.scrollLeft = scrollLeft;
          }
        })
      })
    }
    tableScroll() {
      if (this.targetTable) {
        this.targetTable.addEventListener('scroll', () => {
          this.contentTHs = this.querySelectorAll('th');
          this.contentTHs.forEach(th => {
            const rect = th.getBoundingClientRect();
            const thOffsetLeft = rect.left - 20;
            if (thOffsetLeft == -10) {
              const thItemIndex = th.getAttribute('data-item-index');
              this.stickyBtns.forEach(btn => {
                const btnItemIndex = btn.getAttribute('data-item-index');
                if (thItemIndex == btnItemIndex) {
                  this.stickyBtns.forEach(item => {
                    item.classList.remove('active');
                  });
                  btn.classList.add('active');
                }
              })
            }
          });
        });
      }
    }
    dropwdownChange() {
      this.dropdowns = this.querySelectorAll('.compare-section--dropdown-select');
      this.dropdowns.forEach(dp => {
        dp.addEventListener('change', event => {
          const selectedOption = event.target.selectedOptions[0];
          const currentIndex = selectedOption.dataset.currentIndex;
  
          // Cache DOM elements
          const targetTitle = this.querySelector(`th[data-item-index="${currentIndex}"] .compare-model--title`);
          const targetImg = this.querySelector(`th[data-item-index="${currentIndex}"] .compare-model--image img`);
          const targetColours = this.querySelector(`td[data-item-index="${currentIndex}"].colours .compare-row--colours-wrapper`);
          const targetPerformance = this.querySelector(`td[data-item-index="${currentIndex}"].performance .compare-row--attributes`);
          const targetAdditional = this.querySelector(`td[data-item-index="${currentIndex}"].additional .compare-row--attributes`);
  
          // Update title and image
          if (targetTitle) targetTitle.innerText = selectedOption.dataset.productTitle;
          if (targetImg) targetImg.setAttribute('srcset', selectedOption.dataset.productImage);
  
          // Update colours
          if (targetColours) {
            const productColoursArray = selectedOption.dataset.productColours.split('\n');
            let coloursContent = '';
            productColoursArray.forEach(pColour => {
              const index = this.keyArray.indexOf(pColour.toLowerCase());
              if (index !== -1) {
                coloursContent += `<div class="compare-row--colour-option" style="background-color: ${this.valArray[index]};"></div>`;
              }
            });
            targetColours.innerHTML = coloursContent;
          }
    
          // Update performance attributes
          updateAttribute(targetPerformance, {
            productLength: 'Length',
            productWeight: 'Weight',
            productPackedDown: 'Packed Down',
            productBeam: 'Beam',
            productMaxOutboard: 'Max Outboard'
          });
    
          // Update additional attributes
          updateAttribute(targetAdditional, {
            productCapacity: 'Capacity',
            productSeatsSupplied: 'Seats Supplied',
            productInsideBeam: 'Inside Beam',
            productTubeDiameter: 'Tube Diameter',
            productTransomSpec: 'Transom Spec',
            productScupperSystem: 'Scupper System',
            productFloor: 'Floor',
            productAirChambers: 'Air Chambers',
            productShaftLength: 'Shaft Length'
          });
    
          function updateAttribute(target, attributes) {
            if (!target) return;
            let attributeContent = '';
            Object.entries(attributes).forEach(([dataKey, label]) => {
              const value = selectedOption.dataset[dataKey];
              if (value) {
                attributeContent += `
                  <div class="compare-attribute">
                    <div class="compare-attribute-label">${label}</div>
                    <div class="compare-attribute-value">${value}</div>
                  </div>`;
              }
            });
            target.innerHTML = attributeContent;
          }
        });
      });
    }
  }
  customElements.define('module-five', ModuleFive);
}